import { render, staticRenderFns } from "./AssignModuleBulk.vue?vue&type=template&id=5eed60b2&scoped=true&"
import script from "./AssignModuleBulk.vue?vue&type=script&lang=js&"
export * from "./AssignModuleBulk.vue?vue&type=script&lang=js&"
import style0 from "./AssignModuleBulk.vue?vue&type=style&index=0&id=5eed60b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eed60b2",
  null
  
)

export default component.exports